import type { Dispatch } from "react";
import type { EditorAction } from "../../editor/reducers";
import type { ListRegionTileFragment } from "../../client/generated";
import { useTranslation } from "react-i18next";
import { assertTypeName } from "../../client/guards";
import { RegionTile } from "../../regions/RegionTile";

type Props = {
  fragment: ListRegionTileFragment;
  listAttributeId: string;
  children: React.ReactNode;
  dispatch: Dispatch<EditorAction>;
};

export function ListRegionTile({
  fragment,
  listAttributeId,
  children,
  dispatch,
}: Props) {
  const { t } = useTranslation();

  const listAttribute = fragment.attributes.find(
    (a) => a.id === listAttributeId,
  );
  assertTypeName(listAttribute?.__typename === "ListAttribute");

  const onClick = () => {
    dispatch({
      type: "switchToRegionTab",
      tab: "update",
      regionId: fragment.id,
    });
  };

  return (
    <RegionTile
      fragment={fragment}
      preview={t(`ListRegionTile.preview.${listAttribute.listType}`)}
      onClick={onClick}
    >
      {children}
    </RegionTile>
  );
}
